$(document).ready(function(){
    var popupLink = $(".hiddenPopup");
    if(popupLink.length == 1){
      var type = popupLink.data("type");

      if(type!=null){
        type = type.replace(/\s*$/,"");

        if(type === "inline") {
            popupLink.magnificPopup({
                mainClass: 'mfp-with-zoom',
                removalDelay: 400,
                items: {
                    src: '#popup',
                    type: type
                }
            });
        } else{
            popupLink.magnificPopup({
                type: 'iframe',
                mainClass: 'mfp-with-zoom',
                removalDelay: 400,
                iframe: {
                    markup: '<div class="mfp-iframe-scaler">' +
                    '<div class="mfp-close"></div>' +
                    '<iframe id="player" class="mfp-iframe" frameborder="0" allowfullscreen></iframe>' +
                    '</div>',
                    patterns: {
                        youtube: {
                            index: 'youtube.com/',
                            id: 'v=',
                            src: 'h%id%&autoplay=1'
                        }
                    }
                }
            });
        }
      }
    }
});

$(window).on('load',function () {
    $(".hiddenPopup").trigger("click");
});

$(document).ready(function () {
  $('.js-openMenu').on("click", function () {
    $(this).toggleClass('active');
    $('.mobileMenu').toggleClass('opened');
    $('body').addClass('noscroll');
  });

  $('.js-close').on("click", function () {
    $('.mobileMenu').removeClass('opened');
    $('body').removeClass('noscroll');
  });

  $('body').on("click", '.js-prev', function () {
    
    var el = $(this);
    $(".mobileMenu ul.opened").removeClass("opened");
    $("[data-menu].actived").removeClass("actived");
    $(".js-prev").remove();
  });

  $('.mobileMenu li').each(function() {
    if ( $(this).find('ul').length ) {
      $(this).addClass('withSubmenu');
      $(this).find('a').append('<span class="mobileMenu__submenuSwitcher"></span>');
    }
  });
  

  /* Podmenu rozwija kliknięcie w cały element listy, nie tylko w strzałkę - na telefonie
     trafienie w sam trójkącik było za trudne. Strzałka siedzi w środku linku rodzica
     (ten ma data-menu), więc wystarczy powiesić się na całym linku. */
  function submenuSwitcher() {
    $(".mobileMenu a[data-menu]").on("click", function (e) {
        e.preventDefault();
        var el = $(this);
        el.toggleClass("actived");
        el.next('ul').toggleClass("opened");
    });
  }
  submenuSwitcher();

  $('.js-searchBox .searchBox__icon').on('click', function() {
    $(this).parent().toggleClass('active');
    $('.js-searchBox input').focus();
    $('.mobileMenu__language').toggleClass('hide');
  });

});


document.querySelectorAll('.mobileMenu ul.mobileMenu__list li a[data-menu]').forEach(function(el) {
  el.addEventListener('click', function(e) {
    e.preventDefault();
    e.stopPropagation();
  });
});
var offerBoxesSlider = document.querySelector('.offerBoxesSlider');
if (offerBoxesSlider) {
  var offerBoxesSection = offerBoxesSlider.closest('.investSection');
  var offerBoxesNav = offerBoxesSection ? offerBoxesSection.querySelector('.investSection__nav') : null;

  /* Strzałki chowamy tylko wtedy, gdy nie ma czym przesuwać. Wcześniej decydowała stała
     "mniej niż 4 slajdy", ale liczba widocznych slajdów zależy od szerokości ekranu -
     na mobile widać jeden, więc przy trzech inwestycjach strzałki są potrzebne.
     watchOverflow + isLocked liczy to za nas na każdym breakpoincie. */
  function odswiezOfferBoxesNav(sw) {
    if (offerBoxesNav) offerBoxesNav.hidden = sw.isLocked;
  }

  new Swiper('.offerBoxesSlider', {
    slidesPerView: 3,
    spaceBetween: 24,
    speed: 500,
    watchOverflow: true,
    navigation: {
      prevEl: '.investSection__nav-btn--prev',
      nextEl: '.investSection__nav-btn--next',
    },
    breakpoints: {
      300: {
        slidesPerView: 1,
      },
      576: {
        slidesPerView: 2,
      },
      992: {
        slidesPerView: 3,
      },
    },
    on: {
      init: odswiezOfferBoxesNav,
      breakpoint: odswiezOfferBoxesNav,
      resize: odswiezOfferBoxesNav,
      lock: odswiezOfferBoxesNav,
      unlock: odswiezOfferBoxesNav,
    },
  });
}

 // imageslider
 var elements = document.querySelectorAll('.js-sliderGallery');
 if ( elements.length>0){
   $('.js-sliderGallery').slick({
       arrows: true,
       speed: 700,
       autoplaySpeed: 7000,
       dots: true,
       infinite: true,
       autoplay: true,
       slidesPerRow: 5,
       rows: 2,
       responsive: [
         {
           breakpoint: 678,
           settings: {
             slidesPerRow: 2,
             rows: 2,
           }
         }
       ]
   });
 }


//logoSlider
if ( $('.js-logoSlider').length ){
  $('.js-logoSlider').slick({
      arrows: true,
      speed: 700,
      autoplaySpeed: 7000,
      dots: true,
      infinite: true,
      autoplay: false,
      slidesToShow: 6,
      slidesToScroll: 6,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
              slidesToShow: 4,
              slidesToScroll: 4
          }
        },
        {
          breakpoint: 900,
          adaptiveHeight: false,
          settings: {
              slidesToShow: 2,
              slidesToScroll: 2
          }
        }
        ,
        {
          breakpoint: 600,
          adaptiveHeight: true,
          settings: {
              slidesToShow: 1,
              slidesToScroll: 1
          }
        }
      ]
  });
}
//productSlider
if ( $('.js-productSlider').length ) {
  $('.js-productSlider').slick({
      speed: 700,
      fade: true,
      autoplaySpeed: 7000,
      dots: true,
      infinite: true,
      autoplay: false,
      arrows: true,
      responsive: [
        {
          breakpoint: 1240,
          settings: {
            dots: false
          }
        }
      ]
  });
}

function setTimeSlider() {
  let sliderOpac = $('.slider');
  sliderOpac.addClass('sliderShow');
}

setTimeout(setTimeSlider, 100);

//testimonials
if ( $('.homeTestimonials__slider').length ) {
  $('.homeTestimonials__slider').slick({
      speed: 700,
      fade: true,
      autoplaySpeed: 7000,
      dots: true,
      infinite: true,
      autoplay: false,
      arrows: true,
      responsive: [
        {
          breakpoint: 1240,
          settings: {
            dots: false
          }
        }
      ]
  });
}



document.querySelectorAll('.investGallerySwiper').forEach(function (swiperEl) {
    var wrap = swiperEl.closest('.investGallery__wrap');
    if (!wrap) return;

    /* Gdy zdjęć jest tyle, co widocznych naraz, nie ma czym przewijać - wtedy chowamy cały
       rząd ze strzałkami i paskiem, zamiast pokazywać wygaszone strzałki. isLocked liczy to
       za nas na każdym breakpoincie (watchOverflow niżej). */
    var nav = wrap.querySelector('.investGallery__nav');

    function odswiezNawigacje(sw) {
        if (nav) nav.hidden = sw.isLocked;
    }

    new Swiper(swiperEl, {
        slidesPerView: 4,
        spaceBetween: 24,
        slidesPerGroup: 1,
        watchOverflow: true,
        on: {
            init: odswiezNawigacje,
            breakpoint: odswiezNawigacje,
            resize: odswiezNawigacje,
            lock: odswiezNawigacje,
            unlock: odswiezNawigacje,
        },
        scrollbar: {
            el: wrap.querySelector('.investGallery__scroll'),
            draggable: true,
        },
        navigation: {
            nextEl: wrap.querySelector('.investGallery__btn--next'),
            prevEl: wrap.querySelector('.investGallery__btn--prev'),
        },
        breakpoints: {
            0: {
                slidesPerView: 1,
                spaceBetween: 12,
            },
            600: {
                slidesPerView: 2,
                spaceBetween: 16,
            },
            1024: {
                slidesPerView: 4,
                spaceBetween: 24,
            },
        },
    });
});

document.querySelectorAll('.investGalleryTabs__tab').forEach(function (tab) {
    tab.addEventListener('click', function () {
        var target = tab.getAttribute('data-gallery-tab');
        var tabsWrap = tab.closest('.investGalleryTabs');
        var panelsContainer = tabsWrap ? tabsWrap.parentElement : null;
        if (!tabsWrap || !panelsContainer) return;

        tabsWrap.querySelectorAll('.investGalleryTabs__tab').forEach(function (t) {
            t.classList.remove('investGalleryTabs__tab--active');
        });
        tab.classList.add('investGalleryTabs__tab--active');

        panelsContainer.querySelectorAll('.investGalleryTabs__panel').forEach(function (panel) {
            var isActive = panel.getAttribute('data-gallery-panel') === target;
            panel.classList.toggle('investGalleryTabs__panel--active', isActive);

            if (isActive) {
                var panelSwiperEl = panel.querySelector('.investGallerySwiper');
                if (panelSwiperEl && panelSwiperEl.swiper) {
                    panelSwiperEl.swiper.update();
                }
            }
        });
    });
});



// Baner na stronie głównej. Osobne instancje dla wersji desktop i mobile - oba
// szablony renderują tę samą strukturę, każdy w swoim wrapperze, więc nawigację
// i kropki szukamy wewnątrz konkretnego .banerHomeSlider, a nie globalnie.
document.querySelectorAll('.banerHomeSlider').forEach(function (sliderEl) {
    var swiperEl = sliderEl.querySelector('.banerHomeSlider__swiper');
    if (!swiperEl) return;

    var slidesCount = swiperEl.querySelectorAll('.swiper-slide').length;
    if (slidesCount < 2) return;

    new Swiper(swiperEl, {
        slidesPerView: 1,
        speed: 500,
        loop: true,
        autoplay: {
            delay: 6000,
            disableOnInteraction: false,
        },
        navigation: {
            prevEl: sliderEl.querySelector('.banerHomeSlider__nav-btn--prev'),
            nextEl: sliderEl.querySelector('.banerHomeSlider__nav-btn--next'),
        },
        pagination: {
            el: sliderEl.querySelector('.banerHomeSlider__dots'),
            clickable: true,
        },
    });
});


if (document.querySelector('.newsListMobile')) {
    new Swiper('.newsListMobile', {
        slidesPerView: 1,
        spaceBetween: 24,
        loop:true,
        navigation: {
            prevEl: '.newsListSliderMobile__nav-btn--prev',
            nextEl: '.newsListSliderMobile__nav-btn--next',
        },
        breakpoints: {
            576: {
                slidesPerView: 2,
            },
        },
    });
}
/* Oś postępu prac na stronie inwestycji: taby etapów + osobna oś pod każdym tabem.
   Oś jedzie po jednym punkcie, widoczne 4 punkty na desktopie i 2 na mobile, strzałki
   stoją po bokach i chowają się, gdy punktów nie ma czym przesuwać (swiper.isLocked). */
document.querySelectorAll('.investProgress').forEach(function (section) {
  var panels = section.querySelectorAll('[data-progress-panel]');
  if (!panels.length) return;

  var tabs = section.querySelectorAll('[data-progress-tab]');
  var swipers = {};

  panels.forEach(function (panel) {
    var sliderEl = panel.querySelector('.investProgress__slider');
    if (!sliderEl) return;

    var prev = panel.querySelector('.investProgress__nav-btn--prev');
    var next = panel.querySelector('.investProgress__nav-btn--next');

    function odswiezStrzalki(sw) {
      if (prev) prev.hidden = sw.isLocked;
      if (next) next.hidden = sw.isLocked;
      dopasujDaty();
    }

    /* Data ma rozmiar z makiety, dopóki się mieści. Pełne daty ("27.02.2021") są jednak
       dłuższe od kolumny, a im węższy ekran, tym bardziej - wtedy zbijamy rozmiar tak,
       żeby najdłuższa data weszła w kolumnę. Mierzymy zawsze po zdjęciu --date-font,
       czyli przy rozmiarze bazowym, inaczej przy każdym przeliczeniu tekst by się kurczył.
       Podpisy typu "07.2024" mieszczą się od razu i zostają przy makietowych 36px. */
    function dopasujDaty() {
      var slajdy = panel.querySelectorAll(".investProgress__stage");
      if (!slajdy.length) return;

      panel.style.removeProperty("--date-font");

      var kolumna = slajdy[0].getBoundingClientRect().width;
      var pierwszaData = slajdy[0].querySelector(".investProgress__stage-date p");
      if (!kolumna || !pierwszaData) return;

      var najszersza = 0;
      Array.prototype.forEach.call(slajdy, function (slajd) {
        var data = slajd.querySelector(".investProgress__stage-date p");
        if (data) najszersza = Math.max(najszersza, data.getBoundingClientRect().width);
      });
      if (!najszersza || najszersza <= kolumna) return;

      var bazowy = parseFloat(window.getComputedStyle(pierwszaData).fontSize);
      panel.style.setProperty("--date-font", Math.floor(bazowy * (kolumna - 2) / najszersza) + "px");
    }

    swipers[panel.getAttribute('data-progress-panel')] = new Swiper(sliderEl, {
      slidesPerView: 2,
      slidesPerGroup: 1,
      spaceBetween: 16,
      speed: 500,
      watchOverflow: true,
      breakpoints: {
        769: {
          slidesPerView: 4,
          spaceBetween: 24,
        },
      },
      navigation: {
        prevEl: prev,
        nextEl: next,
      },
      on: {
        init: odswiezStrzalki,
        breakpoint: odswiezStrzalki,
        resize: odswiezStrzalki,
        lock: odswiezStrzalki,
        unlock: odswiezStrzalki,
      },
    });
  });

  /* Etapy mają różną liczbę terminów (a bywa i etap bez terminów), więc panele mają różną
     wysokość i przełączanie zakładek przesuwało treść pod sekcją. Mierzymy najwyższy panel
     i dajemy wszystkim takie samo min-height. Pomiar wymaga chwilowego odsłonięcia panelu -
     dzieje się to w jednym przebiegu, bez przemalowania. */
  function rownajWysokoscOsi() {
    var najwyzszy = 0;

    panels.forEach(function (panel) {
      panel.style.minHeight = '';
      var bylUkryty = panel.hidden;
      if (bylUkryty) panel.hidden = false;
      najwyzszy = Math.max(najwyzszy, panel.offsetHeight);
      if (bylUkryty) panel.hidden = true;
    });

    if (!najwyzszy) return;
    panels.forEach(function (panel) {
      panel.style.minHeight = najwyzszy + 'px';
    });
  }

  rownajWysokoscOsi();
  window.addEventListener('resize', rownajWysokoscOsi);

  tabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      var index = tab.getAttribute('data-progress-tab');

      tabs.forEach(function (other) {
        var czyAktywny = other === tab;
        other.classList.toggle('investProgress__tab--active', czyAktywny);
        other.setAttribute('aria-selected', czyAktywny ? 'true' : 'false');
      });

      panels.forEach(function (panel) {
        panel.hidden = panel.getAttribute('data-progress-panel') !== index;
      });

      /* Kazdy etap ma swoj procent postepu - podmieniamy go razem z osia. Kopii jest dwie
         (nagłówek na desktopie, rząd zakładek na mobile), więc lecimy po wszystkich. */
      var procentEtapu = tab.getAttribute('data-progress-percent');
      if (procentEtapu) {
        section.querySelectorAll('.investProgress__percent-value').forEach(function (procent) {
          procent.textContent = procentEtapu;
        });
      }

      /* Swiper w schowanym panelu policzył szerokości przy zerowym oknie, więc po
         pokazaniu trzeba go przeliczyć - inaczej slajdy zostają z szerokością 0. */
      /* Panel liczył szerokości przy zerowym oknie (był schowany), więc po pokazaniu
         trzeba go przeliczyć. Drugi przebieg w requestAnimationFrame jest po to, żeby
         mierzył już po ułożeniu strzałek - inaczej slajdy zostają z szerokością liczoną
         dla osi bez nich. */
      var swiper = swipers[index];
      if (swiper) {
        swiper.update();
        requestAnimationFrame(function () {
          swiper.update();
          swiper.slideTo(0, 0);
          swiper.emit("resize");
        });
      }
    });
  });
});

/*! modernizr 3.6.0 (Custom Build) | MIT *
 * https://modernizr.com/download/?-webp-setclasses !*/
 !function(e,n,A){function o(e,n){return typeof e===n}function t(){var e,n,A,t,a,i,l;for(var f in r)if(r.hasOwnProperty(f)){if(e=[],n=r[f],n.name&&(e.push(n.name.toLowerCase()),n.options&&n.options.aliases&&n.options.aliases.length))for(A=0;A<n.options.aliases.length;A++)e.push(n.options.aliases[A].toLowerCase());for(t=o(n.fn,"function")?n.fn():n.fn,a=0;a<e.length;a++)i=e[a],l=i.split("."),1===l.length?Modernizr[l[0]]=t:(!Modernizr[l[0]]||Modernizr[l[0]]instanceof Boolean||(Modernizr[l[0]]=new Boolean(Modernizr[l[0]])),Modernizr[l[0]][l[1]]=t),s.push((t?"":"no-")+l.join("-"))}}function a(e){var n=u.className,A=Modernizr._config.classPrefix||"";if(c&&(n=n.baseVal),Modernizr._config.enableJSClass){var o=new RegExp("(^|\\s)"+A+"no-js(\\s|$)");n=n.replace(o,"$1"+A+"js$2")}Modernizr._config.enableClasses&&(n+=" "+A+e.join(" "+A),c?u.className.baseVal=n:u.className=n)}function i(e,n){if("object"==typeof e)for(var A in e)f(e,A)&&i(A,e[A]);else{e=e.toLowerCase();var o=e.split("."),t=Modernizr[o[0]];if(2==o.length&&(t=t[o[1]]),"undefined"!=typeof t)return Modernizr;n="function"==typeof n?n():n,1==o.length?Modernizr[o[0]]=n:(!Modernizr[o[0]]||Modernizr[o[0]]instanceof Boolean||(Modernizr[o[0]]=new Boolean(Modernizr[o[0]])),Modernizr[o[0]][o[1]]=n),a([(n&&0!=n?"":"no-")+o.join("-")]),Modernizr._trigger(e,n)}return Modernizr}var s=[],r=[],l={_version:"3.6.0",_config:{classPrefix:"",enableClasses:!0,enableJSClass:!0,usePrefixes:!0},_q:[],on:function(e,n){var A=this;setTimeout(function(){n(A[e])},0)},addTest:function(e,n,A){r.push({name:e,fn:n,options:A})},addAsyncTest:function(e){r.push({name:null,fn:e})}},Modernizr=function(){};Modernizr.prototype=l,Modernizr=new Modernizr;var f,u=n.documentElement,c="svg"===u.nodeName.toLowerCase();!function(){var e={}.hasOwnProperty;f=o(e,"undefined")||o(e.call,"undefined")?function(e,n){return n in e&&o(e.constructor.prototype[n],"undefined")}:function(n,A){return e.call(n,A)}}(),l._l={},l.on=function(e,n){this._l[e]||(this._l[e]=[]),this._l[e].push(n),Modernizr.hasOwnProperty(e)&&setTimeout(function(){Modernizr._trigger(e,Modernizr[e])},0)},l._trigger=function(e,n){if(this._l[e]){var A=this._l[e];setTimeout(function(){var e,o;for(e=0;e<A.length;e++)(o=A[e])(n)},0),delete this._l[e]}},Modernizr._q.push(function(){l.addTest=i}),Modernizr.addAsyncTest(function(){function e(e,n,A){function o(n){var o=n&&"load"===n.type?1==t.width:!1,a="webp"===e;i(e,a&&o?new Boolean(o):o),A&&A(n)}var t=new Image;t.onerror=o,t.onload=o,t.src=n}var n=[{uri:"data:image/webp;base64,UklGRiQAAABXRUJQVlA4IBgAAAAwAQCdASoBAAEAAwA0JaQAA3AA/vuUAAA=",name:"webp"},{uri:"data:image/webp;base64,UklGRkoAAABXRUJQVlA4WAoAAAAQAAAAAAAAAAAAQUxQSAwAAAABBxAR/Q9ERP8DAABWUDggGAAAADABAJ0BKgEAAQADADQlpAADcAD++/1QAA==",name:"webp.alpha"},{uri:"data:image/webp;base64,UklGRlIAAABXRUJQVlA4WAoAAAASAAAAAAAAAAAAQU5JTQYAAAD/////AABBTk1GJgAAAAAAAAAAAAAAAAAAAGQAAABWUDhMDQAAAC8AAAAQBxAREYiI/gcA",name:"webp.animation"},{uri:"data:image/webp;base64,UklGRh4AAABXRUJQVlA4TBEAAAAvAAAAAAfQ//73v/+BiOh/AAA=",name:"webp.lossless"}],A=n.shift();e(A.name,A.uri,function(A){if(A&&"load"===A.type)for(var o=0;o<n.length;o++)e(n[o].name,n[o].uri)})}),t(),a(s),delete l.addTest,delete l.addAsyncTest;for(var p=0;p<Modernizr._q.length;p++)Modernizr._q[p]();e.Modernizr=Modernizr}(window,document);
$(document).ready(function(){



  var selectPlaceholder = window.Laravel.lang.forms.selectPlaceholder;

  $('.select').select2({
     placeholder: selectPlaceholder,
     minimumResultsForSearch: Infinity, // hide search field,
     language: {
       "noResults": function(){
           return window.Laravel.lang.empty_select;
       }
     }
  });
$('.js-multiselect').select2({
    placeholder: 'Wybierz',
    allowClear: false,
    minimumResultsForSearch: Infinity,
     theme: 'default multipleContainerDropdown',
    multiple: true,
    closeOnSelect: false,
    language: {
        "noResults": function(){
            return window.Laravel.lang.empty_select;
        }
    }
});

  function updateMultiselectSummary($el) {
    var count = ($el.val() || []).filter(function (v) { return v !== '' && v !== null; }).length;
    var $rendered = $el.next('.select2-container').find('.select2-selection__rendered');
    if (count > 0) {
      $rendered.html('<li class="select2-selection__choice select2-selection__choice--count">Wybrano: ' + count + '</li>');
    }
  }

  $('.js-multiselect').each(function () {
    updateMultiselectSummary($(this));
  });

  $('.js-multiselect').on('change', function () {
    updateMultiselectSummary($(this));
  });

  $('.select').on('change', function () {
        $(this).valid();
  });
  $(".select-search").select2({
    //minimumResultsForSearch: 0,
    language: {
      "noResults": function(){
        return window.Laravel.lang.empty_select;
      }
    },
    matcher: function(params, data) {
        if ($.trim(params.term) === '')
          return data;

        if (typeof data.text === 'undefined')
          return null;

        if (data.text.toLowerCase().indexOf(params.term.toLowerCase()) > -1) {
          var modifiedData = $.extend({}, data, true);
          //modifiedData.text += ' (matched)';
          return modifiedData;
        }

        return null;
    },
    templateSelection: function(data) {
      // if(data.selected) //nie wybiera po kliku lub enterze po wyszukiwaniu
        return data.text.trim();
    },
    tokenSeparators: [',', ' ']
  });


  var sortPlaceholder = window.Laravel.lang.offer.sort;

  $('#sortProducts').select2({
      placeholder: sortPlaceholder,
      minimumResultsForSearch: Infinity // hide search field
  });



  $(".filtrPrice .mutliSelect__name").on('click', function() {
    $(".filtrPrice ul").slideToggle('fast');
    $(".filtrColor ul").hide();
    $(".filtrQuality ul").hide();
    $(".filtrSort ul").hide();

  });

  $(".filtrColor .mutliSelect__name").on('click', function() {
    $(".filtrColor ul").slideToggle('fast');
    $(".filtrQuality ul").hide();
    $(".filtrSort ul").hide();
    $(".filtrPrice ul").hide();
  });
  $(".filtrQuality .mutliSelect__name").on('click', function() {
    $(".filtrQuality ul").slideToggle('fast');
    $(".filtrColor ul").hide();
    $(".filtrSort ul").hide();
    $(".filtrPrice ul").hide();


  });
  $(".filtrSort .mutliSelect__name").on('click', function() {
    $(".filtrSort ul").slideToggle('fast');
    $(".filtrColor ul").hide();
    $(".filtrQuality ul").hide();
    $(".filtrPrice ul").hide();

  });

  $(document).bind('click', function(e) {
    var $clicked = $(e.target);
    if (!$clicked.parents().hasClass("mutliSelectWrap")) $(".mutliSelectWrap ul").hide();
  });



});

function initFormValidation(selector) {
    $(selector).each(function () {
        const $form = $(this);

        $form.validate({
            ignore: [],

            errorPlacement: function (error, element) {
                if (element.attr('type') === 'file') {
                    error.insertAfter(element.closest('.styledFormItems--files'));
                } else if (element.closest('.wrapcheckbox').length) {
                    error.insertAfter(element.closest('.wrapcheckbox'));
                } else if (
                    typeof element.attr('data-formmodule-monthyear') !== 'undefined' ||
                    typeof element.attr('data-formmodule-monthmonth') !== 'undefined'
                ) {
                    error.insertAfter(element.parent().find('.select2-container'));
                } else {
                    error.insertAfter(element);
                }
            },

            highlight: function (element) {
                $(element).closest('.styledForm__row').addClass('has-error');
            },

            unhighlight: function (element) {
                $(element).closest('.styledForm__row').removeClass('has-error');
            },

            onfocusout: function (element) {
                $(element).valid();
            }
        });

        $form.find('input[type="file"]').on('change', function () {
            const input = this;
            if (input.files && input.files.length > 0) {
                $(input).valid();
            } else {
                $form.validate().element(input);
            }
        });
    });
}

$('form[id^="moduleForm"]').each(function () {
    initFormValidation(this);
});

initFormValidation('#contactForm');
initFormValidation('#contactPopupForm');
$(document).ready(function(){


  //language - select
  if ($('.languageBox__select').length) {
    $('.languageBox__select').on('click', function() {
        $('.languageBox__list').toggleClass('visible');
        $(this).toggleClass('open');
        return false;
    });
  }

  $('.header__login-withSubmenu').on('click', function(){
      $('.header__login-submenu').slideToggle(300);
  });

  $('.myAcc').on('click', function(){
      event.preventDefault();
  });



  //aos
  if ( $('[data-aos]').length ) {
      AOS.init({
          offset: 50,
          duration: 500
      });
  }

  // lazy loads elements with default selector as '.lozad'
  if ($('.lozad').length) {
    const observer = lozad();
    observer.observe();
  }

  // Handle Lazy loading on page print
  window.onbeforeprint = function() {
    $('.lozad').each(function() {
      var src = $(this).attr('data-src');
      $(this).attr('src', src).parent().addClass('loaded');
    });
  };


  // relax init
  if ($('.rellax').length) {
      var rellax = new Rellax('.rellax', {
        wrapper: '.rellax-parent',
        relativeToWrapper: true,
      });
  }

  // js-up
  $(".js-up").on("click", function () {
      var body = $("html, body");
      body.stop().animate({scrollTop: 0}, 1500, 'swing');
  });

  //search
  $('.js-header__search').on('click', function(){
      $('.header .searchBox').slideToggle(300);
  });
  $('.header .searchBox .searchBox__close').on('click', function(){
      $('.header .searchBox').slideToggle(300);
  });

  $('.searchBoxIcon').on('click', function(){
    $('[data-search-form]').submit();
  });


}); // end document ready

$(window).on("scroll", function () {

// js-up
var scroll = $(window).scrollTop();
if (scroll > 600) {
    $(".js-up").addClass("visible");
} else {
    $(".js-up").removeClass("visible");
}

// scrolled menu
if ($(window).scrollTop() > 0){
  $('.js-header').addClass('header--scrolled');
 }else {
     $(".js-header").removeClass("header--scrolled");
 }

}); // end onscroll



 function animateCounter(el, target, duration) {
    const start = performance.now();
    const update = (now) => {
      const progress = Math.min((now - start) / duration, 1);
      const ease = 1 - Math.pow(1 - progress, 4);
      el.textContent = Math.floor(ease * target).toLocaleString('pl-PL');
      if (progress < 1) requestAnimationFrame(update);
      else el.textContent = target.toLocaleString('pl-PL');
    };
    requestAnimationFrame(update);
  }

  const counters = document.querySelectorAll('.counts__counter');
  let animated = false;

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting && !animated) {
        animated = true;
        counters.forEach(el => animateCounter(el, parseInt(el.dataset.target, 10), 2000));
      }
    });
  }, { threshold: 0.3 });

  observer.observe(document.querySelector('.counts'));



document.querySelectorAll('.investments__tab').forEach(tab => {
  tab.addEventListener('click', () => {
    const target = tab.dataset.tab;

    document.querySelectorAll('.investments__tab').forEach(t => t.classList.remove('investments__tab--active'));
    document.querySelectorAll('.investments__panel').forEach(p => p.classList.remove('investments__panel--active'));
    document.querySelectorAll('.investments__map-panel').forEach(m => m.classList.remove('investments__map-panel--active'));

    tab.classList.add('investments__tab--active');
    document.querySelector(`.investments__panel[data-panel="${target}"]`).classList.add('investments__panel--active');
    document.querySelector(`.investments__map-panel[data-map="${target}"]`).classList.add('investments__map-panel--active');
  });
});

document.querySelectorAll('.investments__list-item[data-marker]').forEach(item => {
  const markerKey = item.dataset.marker;
  const marker = document.querySelector(`.investments__map-marker--${markerKey}`);

  if (!marker) return;

  item.addEventListener('mouseenter', () => marker.classList.add('investments__map-marker--hovered'));
  item.addEventListener('mouseleave', () => marker.classList.remove('investments__map-marker--hovered'));
});

if (document.querySelector('.offerLabels')) {
  console.log('test');
  
  document.querySelector('.sliderDesctopWrap .sliderContent').classList.add('sliderContent--has-offer');
  document.querySelector('.sliderMobileWrap .sliderContent').classList.add('sliderContent--has-offer');

} 
//# sourceMappingURL=front.js.map
